<template>
  <yi-pay-success :pay-amount="payAmount"></yi-pay-success>
</template>

<script>
export default {
  name: 'orderPaySuccess',
  data() {
    return {
      payAmount: 0,
    };
  },
  onLoad(options) {
    const { payAmount } = options;
    this.payAmount = Number(payAmount);
  },
};
</script>

<style scoped></style>
